import { render, staticRenderFns } from "./SlideExpiredCocCop.vue?vue&type=template&id=8577b6ec&"
import script from "./SlideExpiredCocCop.vue?vue&type=script&lang=js&"
export * from "./SlideExpiredCocCop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports